export const TICKETS_RECEIVE_REQUEST = "TICKETS_RECEIVE_REQUEST";
export const TICKETS_RECEIVE_SUCCESS = "TICKETS_RECEIVE_SUCCESS";
export const TICKETS_RECEIVE_FAIL = "TICKETS_RECEIVE_FAIL";

export const TICKET_RECEIVE_REQUEST = "TICKET_RECEIVE_REQUEST";
export const TICKET_RECEIVE_SUCCESS = "TICKET_RECEIVE_SUCCESS";
export const TICKET_RECEIVE_FAIL = "TICKET_RECEIVE_FAIL";

export const TICKET_UPDATE_REQUEST = "TICKET_UPDATE_REQUEST";
export const TICKET_UPDATE_SUCCESS = "TICKET_UPDATE_SUCCESS";
export const TICKET_UPDATE_FAIL = "TICKET_UPDATE_FAIL";

export const TICKET_CREATE_REQUEST = "TICKET_CREATE_REQUEST";
export const TICKET_CREATE_SUCCESS = "TICKET_CREATE_SUCCESS";
export const TICKET_CREATE_FAIL = "TICKET_CREATE_FAIL";

export const GET_CHAT_REQUEST = "GET_CHAT_REQUEST";
export const GET_CHAT_SUCCESS = "GET_CHAT_SUCCESS";
export const GET_CHAT_FAIL = "GET_CHAT_FAIL";

export const POST_CHAT_REQUEST = "POST_CHAT_REQUEST";
export const POST_CHAT_SUCCESS = "POST_CHAT_SUCCESS";
export const POST_CHAT_FAIL = "POST_CHAT_FAIL";

export const ADMIN_STATUS_REQUEST = "ADMIN_STATUS_REQUEST";
export const ADMIN_STATUS_SUCCESS = "ADMIN_STATUS_SUCCESS";
export const ADMIN_STATUS_FAIL = "ADMIN_STATUS_FAIL";

export const ADDTO_CHAT_SUCCESS = "ADDTO_CHAT_SUCCESS";

export const SEND_TRANSCRIPT_REQUEST = "SEND_TRANSCRIPT_REQUEST";
export const SEND_TRANSCRIPT_SUCCESS = "SEND_TRANSCRIPT_SUCCESS";
export const SEND_TRANSCRIPT_FAIL = "SEND_TRANSCRIPT_FAIL";
